import _orderBy from 'lodash/orderBy';

export const getAugmentedAnalyses = (analysesList, analysesData) => {
  if ((!analysesList && !analysesData) || (!analysesList && analysesData)) {
    return [];
  }
  if (!analysesData && analysesList) {
    return analysesList;
  }
  const augmentedAnalyses = analysesList.map((analysisItem) => {
    const analysesDataItemArray = analysesData.analyses.filter(
      (connectionItem) =>
        connectionItem.contentThreadId === analysisItem.contentThreadId
    );
    if (analysesDataItemArray.length) {
      const analysesDataItem = analysesDataItemArray[0];
      return {
        ...analysesDataItem,
        ...analysisItem,
      };
    }
    return analysisItem;
  });

  return augmentedAnalyses;
};
export const sortAnalysesByDate = (analysesList, analysesData) => {
  if ((!analysesList && !analysesData) || (!analysesList && analysesData)) {
    return [];
  }
  if (!analysesData && analysesList) {
    return analysesList;
  }
  const augmentedAnalyses = getAugmentedAnalyses(analysesList, analysesData);
  const sortedAnalyses = _orderBy(
    augmentedAnalyses,
    ['dateModified'],
    ['desc']
  );
  return sortedAnalyses;
};
